// Safe default storage: returns null instead of throwing when sessionStorage is
// unavailable — either absent (SSR / some test runners → ReferenceError, caught
// by the typeof guard) OR present-but-access-throws (sandboxed/privacy contexts
// throw SecurityError on access, caught by the try/catch). Callers evaluate this
// in default-param position, before their own try/catch could catch it, so the
// "never throw on storage access" contract must live here.
export const defaultSessionStorage = () => {
  try {
    return typeof sessionStorage !== "undefined" ? sessionStorage : null;
  } catch (_e) {
    return null;
  }
};
